// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cv-j";
export var fulfillmentFormRail = "_cv-i";
export var headerTitleRow = "_cv-l";
export var orderDetailsWrapper = "_cv-g";
export var orderLinkTrigger = "_cv-2";
export var paymentInformationGrid = "_cv-q";
export var paymentSummaryColumn = "_cv-r";
export var phoneShipmentPickerButton = "_cv-e";
export var phoneShipmentPickerButtonContent = "_cv-f";
export var phoneShipmentPickerButtonWrapper = "_cv-d";
export var phoneShipmentPickerTrigger = "_cv-c";
export var shipmentContainer = "_cv-k";
export var shipmentDetailsMainPane = "_cv-h";
export var shipmentNavigationCard = "_cv-a";
export var shipmentNavigationEdgeTrigger = "_cv-6";
export var shipmentNavigationRail = "_cv-3";
export var shipmentNavigationRailEnter = "_cv-5";
export var shipmentNavigationRailHeader = "_cv-9";
export var shipmentNavigationRailOverlay = "_cv-4";
export var shipmentNavigationScrim = "_cv-7";
export var shipmentSummaryFact = "_cv-n";
export var shipmentSummaryGrid = "_cv-m";
export var shipmentSummaryMetadataRow = "_cv-o";
export var shipmentSummaryTags = "_cv-p";
export var shipmentWorkspace = "_cv-0";
export var shipmentWorkspaceBodyTablet = "_cv-8";
export var shipmentWorkspaceContent = "_cv-b";
export var shipmentWorkspaceHeader = "_cv-1";